import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../loginSlice";

const AuthChecker = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiry = localStorage.getItem("tokenExpiry");
      if (expiry && Date.now() > expiry) {
        dispatch(logout());
      }
    };

    // Check token expiry every 30 seconds
    const interval = setInterval(checkTokenExpiry, 30000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return null; // This component does not render anything
};

export default AuthChecker;
